import { render, staticRenderFns } from "./ViewCountBadge.vue?vue&type=template&id=27150017&"
import script from "./ViewCountBadge.vue?vue&type=script&lang=js&"
export * from "./ViewCountBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports